<template>
  <section class="section-blog-notes" :style="box">
    <div :class="container">

      <div v-if="!!note" class="editor-content" v-html="note">
      </div>
    </div>
  </section>
</template>

<script>
import mixin from '@/mixins/sections/styleSettings'
export default {
  mixins: [mixin],
  computed: {
    note() {
      return this.hasData.note
    }
  }
}
</script>
